import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const ResponsibleMaintenanceService = {
    list: () => axios.get(API_KEEPER + "/ecap-organizations/get-options").then(({ data }) => data).catch((err) => { throw err }),

    get: async (id) => axios.get(API_KEEPER + "/ecap-organizations/" + id).then(({data}) => data).catch((err) => { throw err }),

    create: async (data) => axios.post(API_KEEPER + "/ecap-organizations", data).then(({data}) => data).catch((err) => { throw err }),

    edit: async (id, data) => axios.put(API_KEEPER + "/ecap-organizations/" + id, data).then(({data}) => data).catch((err) => { throw err }),

    delete: async (id) => axios.delete(API_KEEPER + "/ecap-organizations/" + id).catch((err) => { throw err }),
};

export default ResponsibleMaintenanceService;